<template>
  <div class="home">
    <swiper :options="bannerOption" v-if="bannerList.length">
      <template v-for="(item, i) in bannerList">
        <swiper-slide :key="i">
          <img :src="`${options.cdn}/${item}`"/>
        </swiper-slide>
      </template>
      <div class="swiper-pagination" slot="pagination"></div>
    </swiper>

    <div class="column-title italic-font" v-if="collectionList.length">New Collections</div>

    <swiper :options="collectionOption" v-if="collectionList.length && showCollection">
      <template v-for="(item, i) in collectionList">
        <router-link class="swiper-slide hover-border fix" :key="i" :to="`/collections/${item.id}`">
          <img :src="`${options.cdn}/${item.image}`"/>
        </router-link>
      </template>
      <div class="swiper-pagination" slot="pagination"></div>
      <div class="swiper-btn-prev" slot="button-prev"></div>
      <div class="swiper-btn-next" slot="button-next"></div>
    </swiper>

    <div class="column-title italic-font" v-if="projectList.length">Project</div>

    <swiper :options="projectOption" v-if="projectList.length">
      <template v-for="(item, i) in projectList">
        <router-link class="swiper-slide hover-border fix" :key="i" :to="`/project/${item.id}`">
          <img :src="`${options.cdn}/${item.image}`"/>
        </router-link>
      </template>
      <div class="swiper-pagination" slot="pagination"></div>
    </swiper>

  </div>
</template>

<script>
  import { mapGetters, mapState } from 'vuex'
  export default {
    name: 'home',
    components: {},
    data () {
      return {
        showCollection: false,
        bannerOption: {
          speed: 1500,
          autoplay: true,
          loop: true,
          mousewheel: {
            forceToAxis: true
          },
          pagination: {
            el: '.swiper-pagination',
            clickable: true
          }
        },
        projectList: [],
        projectOption: {
          speed: 1500,
          autoplay: true,
          mousewheel: {
            forceToAxis: true
          },
          loop: true,
          pagination: {
            el: '.swiper-pagination',
            clickable: true
          }
        },
        collectionList: []
      }
    },
    computed: {
      ...mapGetters(['isMobile']),
      ...mapState(['options']),
      bannerList () {
        let list = []
        if (this.options && this.options.home_banner && this.options.home_banner.length > 0) {
          list = JSON.parse(this.options.home_banner)
        }
        return list
      },
      collectionOption () {
        return {
          speed: 1500,
          autoplay: true,
          mousewheel: {
            forceToAxis: true
          },
          slidesPerView: this.isMobile ? 2 : 3,
          spaceBetween: 20,
          slidesPerGroup: this.isMobile ? 2 : 3,
          loop: true,
          pagination: {
            el: '.swiper-pagination',
            clickable: true
          },
          navigation: {
            nextEl: '.swiper-btn-prev',
            prevEl: '.swiper-btn-next'
          }
        }
      }
    },
    async mounted () {
      setTimeout(() => {
        this.showCollection = true
      }, 50)

      const collections = this.axios.get('/home/collections')
      const project = this.axios.get('/home/project')

      const [ collectionsData, projectData ] = await Promise.all([collections, project])
      this.projectList = projectData || []
      this.collectionList = collectionsData || []
    }
  }
</script>

<style lang="stylus" scoped>
</style>
